import { createSlice } from '@reduxjs/toolkit';
import { fetchTransactions, exportTransactions } from './Utils/TransactionUtils';

const TransactionSlice = createSlice({
	name: 'Transactions',
	initialState: {
		filters: {
			"filter[id]": "",
			"filter[user.name]": "",
			"filter[user.email]": "",
			"filter[user.phone]": "",
			"filter[membership.title]": "",
			"filter[status]": "",
			"filter[payment_method]": "",
			"filter[created_from]": "",
			"filter[created_to]": "",
			"sort": "",
			"page": "",
		},
		data: [],
		isLoading: false,
		isExport: false,
		exportFileUrl: '',
	},
	reducers: {
		setFilters: (state, action) => {
			state.filters = action.payload;
		},
		clearExportFile: (state) => {
			state.exportFileUrl = '';
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchTransactions.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(fetchTransactions.fulfilled, (state, action) => {
				state.isLoading = false;
				// console.log('status fulfilled', action.payload)
				state.data = action.payload;
				// console.log('data', state.data)
			})
			.addCase(fetchTransactions.rejected, (state) => {
				state.isLoading = false;
			})
			.addCase(exportTransactions.pending, (state) => {
				state.isExport = true;
				state.exportFileUrl = '';
			})
			.addCase(exportTransactions.fulfilled, (state, action) => {
				state.isExport = false;
				state.exportFileUrl = action.payload?.file || '';
			})
			.addCase(exportTransactions.rejected, (state) => {
				state.isExport = false;
				state.exportFileUrl = '';
			})
	}
});

export const { setFilters, clearExportFile } = TransactionSlice.actions;

export default TransactionSlice.reducer;